import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  .simple-date-number {
    @apply --type20;
    top: auto;
    position: relative;
    padding: var(--com-calendar-date-number-padding, 8px);
    right: auto;
    margin: 0 auto;
    width: 27px;
    text-align: center;
    height: 27px;
    border-radius: 50%;
    color: var(--com-calendar-date-action-color, var(--primary-action, #0079BC));
  }

  .simple-date-number.simple-date-number-flex {
    @apply --type18;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:center;
    color: var(--primary-active-contrast, #00233C);
  }

  .simple-date-container.gtg {
    padding: var(--com-calendar-simple-date-container-padding, 0);
  }

  .simple-date-container.gtg .simple-date-number::before {
    position: absolute;
    content: "";
    top: 0.5px;
    right: 0.5px;
    bottom: 0.5px;
    left: 0.5px;
    border: 1.5px solid #008900;
    border-radius: 50%;
  }

  .blocked .simple-date-number .slash line,
  .unavailable .simple-date-number .slash line {
    stroke-linecap: round;
    stroke-width: 2;
    stroke: var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  .blocked .simple-date-number .slash,
  :not([slash-on-blocked-only]).unavailable .simple-date-number .slash {
    display: block;
    position: absolute;
    width: var(--com-calendar-date-slash-dimension-percent, 70%);
    height: var(--com-calendar-date-slash-dimension-percent, 70%);
    top: var(--com-calendar-date-slash-start-offset, 15%);
    left: var(--com-calendar-date-slash-start-offset, 15%);
  }

  .simple-date-container[disabled] .simple-date-number,
  .simple-date-container[allow-disabled-focus] .simple-date-number {
    color: var(--com-calendar-date-disabled-number-color, var(--inactive-grey));
  }

</style>
</template>`;

styleElement.register('com-calendar-basic-style');